import { identifyClarityUser } from '../../config/clarity';
import { identifyUserForGA } from '../../config/googleAnalytics';
import { ObjectIdString } from '../../types/common';
import { isDevEnv, userConsentGiven } from '../environment';

export enum PageName {
    issue = 'issue',
    fileUpload = 'file-upload',
    personalDataOnOrganization = 'organization-personal-data',
    personalData = 'all-personal-data',
}

export function identifyUserAndPage(
    userId: ObjectIdString,
    pageName: PageName,
    userEmail: string,
) {
    if (!isDevEnv() && userConsentGiven()) {
        identifyUserForGA(userId, { userEmail });
        identifyClarityUser(userId, pageName, userEmail);
    }
}
